import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay, Manipulation } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Manipulation]);

if (!customElements.get('featured-collections')) {
  class featuredCollections extends HTMLElement {
    constructor() {
      super();
      this.swiper = this.querySelector('[data-swiper]');

      // Stop when the swiper is not found
      if (!this.swiper) {
        return;
      }

      // Default to improve user experience
      this.swiperOptions = {
        threshold: 10,
      };

      // Check if we have extra options on the HTML
      if (this.swiper.dataset.options) {
        const options = JSON.parse(this.swiper.dataset.options);
        if (options) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...options,
          };
        }
      }

      // Call swiper with selected swiper element and options
      this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

      // Global vars
      this.collectionButton =
        this.querySelector('.featured-collections__collection-button > a') || false;
      this.maxProducts = parseInt(this.swiper.dataset.products) || 3;
      this.maxSlides = this.maxProducts + 1;

      // Event listener collection navigation clicks
      this.collectionNavigationEvents();

      /**
       * Listen to extra events when in Shopify editor
       */
      if (Shopify.designMode) {
        // Update the swiper when the section event is triggerd
        window.addEventListener('shopify:section:load', (event) => {
          this.swiperInstance.update();
          if (this.swiperOptions.navigation) {
            this.swiperInstance.navigation.init();
            this.swiperInstance.navigation.update();
          }
        });

        // When on block select go to the slide in front-end
        window.addEventListener('shopify:block:select', (event) => {
          this.swiperInstance.update();
          if (this.swiperOptions.navigation) {
            this.swiperInstance.navigation.init();
            this.swiperInstance.navigation.update();
          }
          this.handleBlockSelect(event);
        });

        // When on block deselect go to the slide in front-end
        window.addEventListener('shopify:block:deselect', (event) => {
          this.swiperInstance.update();
          if (this.swiperOptions.navigation) {
            this.swiperInstance.navigation.init();
            this.swiperInstance.navigation.update();
          }
          this.handleBlockSelect(event);
        });
      }
    }

    /**
     * collectionNavigationEvents
     * @description Fetches() collection products as sliders
     */
    collectionNavigationEvents() {
      const collectionNavigation = this.querySelectorAll('[data-collection-handle]');
      collectionNavigation.forEach((item) => {
        const handle = item.dataset.collectionHandle || false;

        if (handle) {
          item.addEventListener('click', (event) => {
            this.classList.add('loading');
            this.renderCollectionButton(handle);
            this.getCollectionProducts(handle);

            // Handles active status
            const activeBefore =
              this.querySelector('.featured-collections__nav__item.active') || false;
            if (activeBefore) activeBefore.classList.remove('active');
            event.target.classList.add('active');
          });
        }
      });
    }

    /**
     * renderCollectionButton
     * @description Changes the button content
     */
    renderCollectionButton(handle = false) {
      if (handle && this.collectionButton) this.collectionButton.href = `collections/${handle}/`;
    }

    /**
     * getCollectionProducts
     * @description Fetches() collection products as sliders
     */
    getCollectionProducts(handle = false) {
      if (handle) {
        const origin = window.Shopify.routes.root;
        const currentCollection = `collections/${handle}/`;
        const section = `featured-collections-feed`;
        const url = `${origin}${currentCollection}?section_id=${section}`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const nodeList = html.querySelectorAll('.swiper-slide');
            const slideList = Array.from(nodeList);
            if (slideList.length > 0) {
              if (slideList.length > this.maxSlides)
                slideList.splice(this.maxProduct, slideList.length - this.maxSlides);
              this.swiperInstance.removeAllSlides();
              this.swiperInstance.appendSlide(slideList);
            }
            this.classList.remove('loading');
          });
      }
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleBlockSelect(event) {
      // Check if the slide index is set
      if (!('swiperSlideIndex' in event.target.dataset)) {
        return;
      }

      // Set the slide index based on loop settings or not
      let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
      if (this.swiperOptions.loop) {
        swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
      }

      // Slide to slide based on the data attribute from the target
      this.swiperInstance.slideTo(swipeToSlideIndex, 1000);
    }
  }

  window.featuredCollections = featuredCollections;

  customElements.define('featured-collections', featuredCollections);
}
